module.exports = __webpack_public_path__ + "img/new-seash.56829e96.svg";